export const ESP_ASSET_TREND_BY_TAGS_PARAM_STD_TYPES = [1, 2];

export const GL_ASSET_TREND_BY_TAGS_PARAM_STD_TYPES = [196, 191];

export const ESP_ANALYSIS_BY_TAGS_PARAM_STD_TYPES = [2, 1, 186, 9, 314, 145, 223, 218, 190, 185];

export const GL_ANALYSIS_BY_TAGS_PARAM_STD_TYPES = [191, 238, 209, 196, 9, 2223, 218, 190, 185];
